<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <div class="create-model-steps-wrapper">
                    <v-btn @click="addStep" rounded="lg">Schritt hinzufügen</v-btn>
                    <v-btn @click="saveModel" rounded="lg">Modell speichern</v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row v-for="(step, index) in steps" :key="index">
            <v-col cols="12" md="1">
                <v-text-field v-model.number="step.start" label="Start" type="number" @input="calculate"></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
                <v-text-field v-model.number="step.end" label="Ende" type="number" @input="calculate"></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
                <v-text-field v-model.number="step.price" label="Preis pro Slot" type="number"
                    @input="calculate"></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
                <div>Kunden: {{ step.customers }}</div>
            </v-col>
            <v-col cols="12" md="1">
                <div>Gesamtkosten: {{ step.totalCost }}€</div>
            </v-col>
            <v-col cols="12" md="1" class="d-flex align-center">
                <v-btn rounded="lg" class="text-none" @click="removeStep(index)">Schritt entfernen
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>Gesamtübersicht</v-card-title>
                    <v-card-text>
                        <div>Gesamtkunden: {{ totalCustomers }}</div>
                        <div>Gesamtkosten: {{ totalCost }}€</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>Slots in Benutzung</v-card-title>
                    <v-card-text>
                        <v-table>
                            <thead>
                                <tr>
                                    <th v-for="(slot, index) in slotData" :key="'header-' + index" class="text-left">
                                        {{ slot.title }} Slot
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td v-for="(slot, index) in slotData" :key="'value-' + index">
                                        {{ slot.value }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <SlotModelCharts></SlotModelCharts>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SlotModelCharts from './SlotModelCharts.vue';

export default {
    data() {
        return {
            slotData: [
                { title: 1, value: 58 },
                { title: 2, value: 55 },
                { title: 3, value: 108 },
                { title: 4, value: 16 },
                { title: 5, value: 18 },
                { title: 6, value: 17 },
                { title: 7, value: 17 },
                { title: 8, value: 11 },
                { title: 9, value: 19 },
                { title: 10, value: 45 },
                { title: 11, value: 8 },
                { title: 12, value: 5 },
                { title: 13, value: 3 },
                { title: 14, value: 6 },
                { title: 15, value: 8 },
                { title: 16, value: 2 },
                { title: 17, value: 3 },
                { title: 18, value: 11 },
                { title: 19, value: 3 },
                { title: 20, value: 1 },
                { title: 22, value: 2 },
                { title: 23, value: 4 },
                { title: 24, value: 3 },
                { title: 25, value: 3 },
                { title: 27, value: 2 },
                { title: 28, value: 1 },
                { title: 29, value: 2 },
                { title: 30, value: 6 },
                { title: 34, value: 1 },
                { title: 37, value: 1 },
                { title: 39, value: 1 },
                { title: 40, value: 1 },
                { title: 43, value: 1 },
                { title: 47, value: 1 },
                { title: 50, value: 2 },
                { title: 53, value: 2 },
                { title: 59, value: 1 },
                { title: 60, value: 3 },
                { title: 78, value: 1 },
                { title: 83, value: 1 },
            ],
            steps: [
                { start: 1, end: 5, price: 15, customers: 0, totalCost: 0 },
            ],
            totalCustomers: 0,
            totalCost: 0,
        };
    },
    components: {
        SlotModelCharts
    },
    created() {
        this.calculate();
    },
    computed: {
        ...mapState('marketing', ['loading', 'loadedModels']),
    },
    methods: {
        ...mapActions('marketing', ['savePriceModel']),
        addStep() {
            const lastStep = this.steps[this.steps.length - 1];
            const newStart = lastStep.end + 1;
            const newEnd = newStart + 4;
            this.steps.push({ start: newStart, end: newEnd, price: 15, customers: 0, totalCost: 0 });
            this.calculate();
        },
        removeStep(index) {
            this.steps.splice(index, 1);
            this.calculate();
        },
        calculate() {
            this.totalCustomers = 0;
            this.totalCost = 0;

            this.steps.forEach(step => {
                let customers = this.slotData.reduce((sum, slot) => {
                    if (slot.title >= step.start && slot.title <= step.end) {
                        return sum + slot.value;
                    }
                    return sum;
                }, 0);
                step.customers = customers;
                step.totalCost = customers * step.end * step.price;
                this.totalCustomers += customers;
                this.totalCost += step.totalCost;
            });
        },
        saveModel() {
            const model = {
                steps: this.steps,
                totalCustomers: this.totalCustomers,
                totalCost: this.totalCost
            };
            this.$store.dispatch('marketing/savePriceModel', model);
        },
    }
};
</script>

<style lang="scss" scoped>

.create-model-steps-wrapper {
    display: flex;
    flex-direction: row;
    gap: 12px;
}


</style>